module.exports = __webpack_public_path__ + "img/mobile/SmartButton-promo/btn-spin@3x.png?0.0.53";